import {
  Anagha_Sivadas,
  Hanna_Salam,
  Hemanth_R,
  Nayana_Vinod,
  Nikita_menon,
  Shimil,
  Sony_P,
  TomVempala,
  Vishruth_Subramanian,
} from "../../assets/team/teamImages";

import {
  Athul_Reji,
  George_Sabu,
  Jagannath_E_Shahi,
  Jessica_Jolly,
  SharatJacob,
} from "../../assets/team/teamImages";

export const year = "2021-22";
export const isCurrent = false;

export const coreSlices = [
  [0, 4],
  [4, 9],
];

export const core = [
  {
    id: 1,
    name: "Sony P",
    title: "Faculty Advisor",
    image: Sony_P,
    linkedIn: "",
  },
  {
    id: 2,
    name: "Vishruth S",
    title: "Chairperson",
    image: Vishruth_Subramanian,
    linkedIn: "https://www.linkedin.com/in/vishruth-subramanian/",
  },
  {
    id: 3,
    name: "Nayana Vinod",
    title: "Vice-Chairperson",
    image: Nayana_Vinod,
    linkedIn: "https://www.linkedin.com/in/nayana-vinod",
  },
  {
    id: 4,
    name: "Tom Thomas",
    title: "CP Head",
    image: TomVempala,
    linkedIn: "https://www.linkedin.com/in/tom-vempala-6175ab175/",
  },
  {
    id: 5,
    name: "Anagha Sivadas",
    title: "Events Head",
    image: Anagha_Sivadas,
    linkedIn: "https://www.linkedin.com/in/anagha-sivadas",
  },
  {
    id: 6,
    name: "Hanna Salam",
    title: "Outreach Head",
    image: Hanna_Salam,
    linkedIn: "https://www.linkedin.com/in/hanna-salam",
  },
  {
    id: 7,
    name: "Shimil Abraham",
    title: "Design Head",
    image: Shimil,
    linkedIn: "https://www.linkedin.com/in/shimil-abraham-47049a1b6",
  },
  {
    id: 8,
    name: "Hemanth R",
    title: "Tech Head",
    image: Hemanth_R,
    linkedIn: "https://www.linkedin.com/in/hhhrrrttt222111/",
  },
  {
    id: 9,
    name: "Nikita Menon",
    title: "Content Head",
    image: Nikita_menon,
    linkedIn: "https://www.linkedin.com/in/nikita-menon-b2248079",
  },
];

export const teams = [
  {
    name: "Competitive Programming",
    members: [
      { name: "Tom Thomas" },
      { name: "George Sabu" },
      { name: "Gautham S Baiju" },
      { name: "Athul Reji" },
      { name: "Jagannath E Shahi" },
      { name: "Snehal Sha" },
      { name: "George Mathew Pappady" },
    ],
  },
  {
    name: "Tech Team",
    members: [
      { name: "Hemanth R" },
      { name: "Gayathry S" },
      { name: "Aadhil Farhan K S" },
      { name: "Deepak Mathew" },
      { name: "Sona Mathew" },
      { name: "Sreehari Sreekumar" },
      { name: "Jaison Dennis" },
      { name: "Vishnu R Potti" },
      { name: "Amjad Ali" },
      { name: "Lisa V Cherian" },
    ],
  },
  {
    name: "Content Team",
    members: [
      { name: "Sharat Jacob Jacob" },
      { name: "Stephen Saji Mathew " },
      { name: "Sneha shaji" },
      { name: "Reshma J Nair" },
      { name: "Sonah S Tiju" },
      { name: "Anish Pillai" },
      { name: "Ann Maria" },
      { name: "Mrinalini Nair Ani" },
      { name: "Diya Naushad" },
    ],
  },
  {
    name: "Design Team",
    members: [
      { name: "Shimil S Abraham" },
      { name: "Jessica Jolly" },
      { name: "Ashwin Girish" },
      { name: "Hana Shelbin" },
      { name: "Jeswin Thomas" },
      { name: "Netanya Jaison" },
      { name: "Kuriakose T Cyril" },
      { name: "Jemma Mariya George" },
      { name: "Adhil" },
      { name: "Henna k" },
      { name: "Annu Kuruvilla" },
      { name: "Anish Pillai" },
      { name: "Gourisankar Shaji" },
    ],
  },
  {
    name: "Outreach Team",
    members: [
      { name: "Hanna Salam" },
      { name: "Fayaz A P" },
      { name: "Arathy Sha A" },
      { name: "Sreehari Sreekumar" },
      { name: "Kalyani Reji" },
    ],
  },
  {
    name: "Events Team",
    members: [
      { name: "Anagha Sivadas" },
      { name: "Elizabeth Mathew" },
      { name: "Maria Rachel Joseph" },
      { name: "Swathy Prakash " },
      { name: "K B Sree Lakshmy " },
      { name: "Rose Mariya Davis " },
      { name: "Lakshmi Sajilal" },
      { name: "Crystal Bejoy" },
      { name: "K B Sree Parvathy" },
    ],
  },
  {
    name: "Publicity Team",
    members: [
      { name: "Jaison Dennis" },
      { name: "Ann Maria" },
      { name: "Medha K" },
      { name: "J Vikaas" },
      { name: "Jubel Benny" },
      { name: "Sumayya Parvin" },
      { name: "Swathi Satheesh Chandran" },
      { name: "Saad Moopan" },
      { name: "Roshna Sunil" },
      { name: "Arjun Jayakumar" },
    ],
  },
];

export const exec = [
  {
    id: 1,
    name: "George Sabu",
    image: George_Sabu,
    linkedIn: "https://www.linkedin.com/in/george-sabu-63370717a",
  },
  {
    id: 2,
    name: "Athul Reji",
    image: Athul_Reji,
    linkedIn: "https://www.linkedin.com/in/athul-reji-a99ab2201",
  },
  {
    id: 3,
    name: "Jagannath E Sahi",
    image: Jagannath_E_Shahi,
    linkedIn: "https://www.linkedin.com/in/jagannath-e-shahi-3b0525202",
  },
  {
    id: 4,
    name: "Sharat Jacob",
    image: SharatJacob,
    linkedIn: "https://www.linkedin.com/in/sharat-jacob-jacob",
  },
  {
    id: 5,
    name: "Jessica Jolly",
    image: Jessica_Jolly,
    linkedIn: "https://www.linkedin.com/in/jessica-jolly-b424841aa/",
  },
];
